import { h } from "../kit/dom.ts";

/** Anel de carga em volta da mira e contador da Aljava (doc 05, HUD: mira com barra de carga). */
export class BowHud {
  private readonly ring: HTMLElement;
  private readonly count: HTMLElement;
  private shown = "";

  constructor(parent: HTMLElement) {
    this.ring = h("div", { id: "carga", "aria-hidden": "true" });
    this.count = h("div", { id: "aljava", "aria-label": "Flechas na Aljava" });
    parent.append(this.ring, this.count);
  }

  /** `arrows` indefinido = sem arco na mão (esconde tudo). */
  update(charge: number, charging: boolean, arrows: number | undefined): void {
    this.ring.style.display = charging ? "block" : "none";
    if (charging) {
      this.ring.style.setProperty("--p", charge.toFixed(3));
      this.ring.classList.toggle("cheia", charge >= 1);
    }
    const text = arrows === undefined ? "" : arrows > 0 ? `${arrows} flechas` : "sem flechas na Aljava";
    if (text === this.shown) return;
    this.shown = text;
    this.count.textContent = text;
    this.count.style.display = text ? "block" : "none";
    this.count.classList.toggle("vazia", arrows === 0);
  }

  remove(): void {
    this.ring.remove();
    this.count.remove();
  }
}
